import { Injectable } from '@angular/core';
import { Tile, ExampleTab, Topics , Channels, Notification, BoardSocialMediaContent, Privacy, Links, Settingsmenu, SettingsMenuInfo, SocialMediaAccounts, FollowersOfBoard, SocialMediaChannels} from '../../modele/dummyModel';

import { User } from '../../modele/user/userModel';
import {Board, UserRelatedBoards, UserRelatedBoard} from '../../modele/boardModel';
import { Observable, of } from 'rxjs';


import { BOARDS, USERRELATEDBOARDS, USER, TOPICS, CHANNELS, NOTIFICATIONS, PRIVACY, LINKS, SOCIALMEDIACHANNELS, BOARDSOCIALMEDIACONTENT, TILESABOUTWHOOOSH, SETTINGSMENU, SETTINGSMENUINFO, SOCIALMEDIAACOUNTS, FOLLOWEROFBOARD } from '../../data/dummydata';
import { TILES, TILESNOTLOGGEDIN, DASHBOARDBUTTONS } from '../../data/dummydata';
import {Topic} from "../../modele/topicModel";


@Injectable({
  providedIn: 'root'
})
export class DummydataService {

  constructor() { }

  getBoards(): Board[] {
      return BOARDS;
  }
  getBoardsPostFromNetwork(): BoardSocialMediaContent[] {
      return BOARDSOCIALMEDIACONTENT;
  }
  getUserRelatedBoards(): UserRelatedBoard[] {
      return USERRELATEDBOARDS;
  }
  getSocialMediaChannels(): SocialMediaChannels[] {
      return SOCIALMEDIACHANNELS;
  }
  getFollowerList(): FollowersOfBoard[] {
      return FOLLOWEROFBOARD;
  }
  getSocialMediaAcounts(): SocialMediaAccounts[] {
      return SOCIALMEDIAACOUNTS;
  }
  getUser(): User[] {
      return USER;
  }
  getTopics(): Topic[] {
      return TOPICS;
  }
  getSettingMenuInfo(): SettingsMenuInfo[] {
      return SETTINGSMENUINFO;
  }
  getPrivacy(): Privacy[] {
      return PRIVACY;
  }
  getChannels(): Channels[] {
      return CHANNELS;
  }
  getNotifications(): Notification[] {
      return NOTIFICATIONS;
  }
  getTiles(): Tile[] {
      return TILES;
  }
  getTilesAboutWhooosh(): Tile[] {
      return TILESABOUTWHOOOSH;
  }
  getLinks(): Links[] {
      return LINKS;
  }
  getSettingsmenu(): Settingsmenu[] {
      return SETTINGSMENU;
  }
  getTilesNotLoggedIn(): Tile[] {
      return TILESNOTLOGGEDIN;
  }
  getDashboardButtons(): ExampleTab[] {
      return DASHBOARDBUTTONS;
  }
  getBoardInfo(name: string): Observable<Board> {
    return of(BOARDS.find(board => board.board_name === name));
  }

  getUserInfoForProfil(name: string): Observable<User> {
    return of(USER.find(user => user.user_name === name));
  }
  getUserInfoForLocalUser(id: number): Observable<User> {
    return of(USER.find(user=> user.user_id === id));
  }
  getUserInfo(name: string): Observable<User> {
    return of(USER.find(user => user.user_name === name));
  }
  getUserInfo2(id: number): Observable<User> {
    return of(USER.find(user => user.user_id === id));
  }
  getUserRelatedBoardInfo(name: string): Observable<UserRelatedBoard> {
  return of(USERRELATEDBOARDS.find(board => board.board_name === name));
  }


}
